<template>
  <div class="modal">
    <v-snackbar v-model="snackbar" timeout="3000"
      >Aktion erfolgreich ausgeführt.
    </v-snackbar>

    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
        scrollable
        :fullscreen="$vuetify.breakpoint.xs ? true : false"
        :transition="
          $vuetify.breakpoint.xs
            ? 'dialog-bottom-transition'
            : 'dialog-transition'
        "
      >
        <v-card :disabled="loading">
          <v-card-title>
            <span class="headline">Verlängerungstermin absagen</span>
          </v-card-title>
          <v-card-subtitle class="pt-2">{{
            `${selection.length} ${
              selection.length === 1 ? "Eintrag ist" : "Einträge sind"
            } ausgewählt für Terminabsage`
          }}</v-card-subtitle>
          <v-card-text v-if="!showSuccess">
            <!-- <div class="body-2">
                Die Aktualisierungsrichtlinie für diese Frist erlaubt es,
                Aktualisierungen am eigenen Fristenstatus vorzuschlagen
                (Genehmigungsprozess erforderlich).
              </div> -->
            <v-spacer style="height: 20px"></v-spacer>
            <v-form v-model="formIsValid" @submit.prevent>
              <v-form
                v-model="formIsValid"
                ref="rejectDialogForm"
                @submit.prevent="rejectUpdateRequests()"
              >
                <v-select
                  v-model="data.cancellationReason.id"
                  :items="reasonItems"
                  label="Begründung für Status auswählen"
                  small-chips
                  :rules="[rules.required]"
                  outlined
                  hide-details="auto"
                >
                </v-select>
                <v-textarea
                  v-model="data.cancellationReason.details"
                  label="Ergänzende Information zur Begründung (Optional)"
                  persistent-hint
                  outlined
                  rows="3"
                  auto-grow
                  hide-details="auto"
                  class="mt-2 pb-0"
                ></v-textarea>
                <v-checkbox
                  v-model="data.notifyPersons"
                  label="Person(en) über Terminabsage benachrichtigen"
                ></v-checkbox>
                <v-textarea
                  v-model="data.notificationText"
                  outlined
                  label="Mitteilung"
                  auto-grow
                  required
                  rows="3"
                  hint="Neben der Benachrichtigung über die Terminabsage wird diese Mitteilung an betroffene Personen gesendet."
                  persistent-hint
                  class="pb-0"
                ></v-textarea>
              </v-form>
            </v-form>
          </v-card-text>
          <v-card-text v-if="errorMessage !== ''">
            <v-alert dense text type="error"> {{ errorMessage }} </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="$emit('close')">Abbrechen</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!formIsValid"
              :loading="loading"
              depressed
              color="primary"
              @click="cancelRenewals()"
            >
              Bestätigen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { functions, Timestamp } from "@/firebase";
export default {
  name: "deadline-entry-renewal-cancel-dialog",
  props: {
    deadlineEntry: {
      type: Object,
      required: true,
    },
    selection: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || "Ist erforderlich.",
      },
      licenseKey: "",
      formIsValid: false,
      loading: false,
      showSuccess: false,
      errorMessage: "",
      dialog: true,
      snackbar: false,
      data: {
        cancellationReason: {
          details: "",
          id: null,
        },
        notifyPersons: true,
        notificationText: "",
      },
      reasonItems: [
        { text: "Krankheit", value: "illness" },
        {
          text: "Verpflichtungen/Verbindlichkeiten/Termine",
          value: "commitments",
        },
        { text: "Externe Absage", value: "external_cancellation" },
        { text: "Organisatorische Gründe", value: "organizational_reasons" },
        { text: "Termin nicht mehr erforderlich", value: "not_required" },
        { text: "Frist bereits erfüllt", value: "already_completed" },
        { text: "Verschiebung auf anderen Zeitpunkt", value: "postponed" },
        { text: "Sonstiges", value: "other" },
      ],
    };
  },
  methods: {
    convertToTimestamp(date, time) {
      const input = date + " " + time;
      return Timestamp.fromDate(new Date(input.replace(/-/g, "/")));
    },
    cancelRenewals() {
      this.loading = true;
      this.errorMessage = "";
      const selectedDeadlineEntryIds = this.selection.map(
        (entry) => entry.meta.id
      );

      const callFunction = functions.httpsCallable(
        "memberManagement-cancelDeadlineEntryRenewals"
      );
      callFunction({
        organizationId: this.$route.params.organizationId,
        deadlineEntryIds: selectedDeadlineEntryIds,
        cancellationReason: {
          details: this.data.cancellationReason.details,
          id: this.data.cancellationReason.id,
        },
        notifyUser: this.data.notifyPersons,
        notificationText: this.data.notificationText,
      })
        .then((result) => {
          console.log(result.data);
          if (result.data.success) {
            this.showSuccess = true;
            this.snackbar = true;
            this.loading = false;
            this.$emit("close");
          } else {
            this.errorMessage = "Unbekannter Fehler aufgetreten.";
            this.loading = false;
          }
        })
        .catch((error) => {
          // handle error
          console.error(error);
          this.errorMessage = error.message;
          this.loading = false;
        });
    },
  },
};
</script>
